import { Col, Row, Typography } from "@codat/orchard-ui";
import React, { PropsWithChildren } from "react";

import styles from "./PageHeader.module.css";

interface PageHeaderProps {
  header: string;
  underline?: boolean;
}

const PageHeader: React.FC<PropsWithChildren<PageHeaderProps>> = ({
  header,
  underline,
  children,
}) => {
  return (
    <>
      <Row>
        <Col size={12} className={styles.headerContainer}>
          <Typography
            variant="heading_xxl"
            as="h1"
            className={styles.header}
            data-testid="page-title"
          >
            {header}
          </Typography>
          {children}
        </Col>
      </Row>
      {underline && <Row className={styles.line}></Row>}
    </>
  );
};

export default PageHeader;
